<div class="list-container">
  @for (item of items; track item) {
    <div class="list-item">
      @for (prop of displayProperties; track prop) {
        <span>{{ item[prop] }} </span>
      }
      @if (shouldShowDeleteButton()) {
        <button mat-icon-button class="remove-btn" aria-label="Remove item" (click)="onRemove(item)">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  }
</div>
